import { useNavigate } from 'react-router-dom'
import { useModal } from '@context/ModalContext'
import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { User } from '@apis'

import Table from '@components/table'
import { eye } from '@assets/icons'
import { CircleCheck, CircleX, Eye } from 'lucide-react'
import theme from '@utils/theme'
import { StatusUpdateModal } from '@commons/status-update-modal'

interface UserTableProps {
  title: string
  icon: string
  columns: any[]
  isInDashboard?: boolean
  role?: string
  status?: string
}

const Users: FC<UserTableProps> = ({
  title,
  icon,
  columns,
  isInDashboard = false,
  role,
  status,
}) => {
  const { showModal, hideModal } = useModal()
  const [searchTerm] = useState('')
  const {
    items: users,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.users)
  const [page, setPage] = useState(1)

  const fetchUsers = async (search = '', page = 1) => {
    try {
      await User.list({
        state: 'users',
        params: {
          page,
          limit: isInDashboard ? 4 : 20,
          search,
          role: !!role ? role : 'user',
          status,
        },
      })
    } catch (error) {}
  }

  const navigate = useNavigate()

  useEffect(() => {
    fetchUsers(searchTerm, page).then(() => {})
  }, [page, searchTerm])

  const defaultActions = [
    {
      icon: eye,
      onClick: (item: any) =>
        navigate(`/admin/user-management/users/${item.id}`, { state: item.id }),
      key: 'view',
    },
  ]
  const providerActions = [
    {
      key: 'view',
      icon: <Eye size={14} color={theme.colors.primary} />,
      onClick: (row: any, e: any) => {},
    },
    {
      key: 'verify',
      icon: <CircleCheck size={14} color="#4CAF50" />,
      onClick: (row: any, e: any) => {
        e.stopPropagation()
        showModal(
          <StatusUpdateModal
            item={row}
            actionType={'verify'}
            hideModal={hideModal}
          />,
        )
      },
    },
    {
      key: 'reject',
      icon: <CircleX size={14} color="#E72929" />,
      onClick: (row: any, e: any) => {
        e.stopPropagation()
        showModal(
          <StatusUpdateModal
            item={row}
            actionType={'reject'}
            hideModal={hideModal}
          />,
        )
      },
    },
  ]

  const actionafterrejection = []
  return (
    <Table
      loading={loading}
      columns={columns}
      data={users}
      itemsPerPage={20}
      text={title}
      icon={icon}
      searchKeys={['email']}
      onPageChange={setPage}
      pageControlled={page}
      totalItems={totalItems}
      totalPages={totalPages}
      {...(!isInDashboard && {
        actions:
          role === 'operator' && status === 'Request'
            ? providerActions
            : status === 'Rejected'
              ? actionafterrejection
              : defaultActions,
      })}
      onRowClick={(data) =>
        navigate(
          `/admin/user-management/${role === 'operator' ? 'providers' : 'users'}/${data.id}`,
          {
            state: data.id,
          },
        )
      }
      hasExportButton={true}
      savedTitle={
        role === 'operator'
          ? status === 'Request'
            ? 'providerrequest.pdf'
            : status === 'Rejected'
              ? 'providerrejected.pdf'
              : status === 'Verified'
                ? 'providerverified.pdf'
                : 'provider.pdf'
          : 'user.pdf'
      }
    />
  )
}

export default Users

const Verify = ({ item }) => {
  const { hideModal } = useModal()
  return (
    <>
      <p>You want to verify? this cannot be undone</p>
      <button onClick={() => hideModal()}>no</button>
      <button
        onClick={async () => {
          User.verifyOperator({
            state: 'users',
            id: item.id,
            data: { status: 'Verified' },
          }).then(() => {
            window.location.reload()
            hideModal()
          })
        }}
      >
        yes
      </button>
    </>
  )
}
const Reject = ({ item }) => {
  const { hideModal } = useModal()
  return (
    <>
      <p>You want to reject? this cannot be undone</p>
      <button onClick={() => hideModal()}>no</button>
      <button
        onClick={async () => {
          User.verifyOperator({
            state: 'users',
            id: item.id,
            data: { status: 'Rejected' },
          }).then(() => {
            window.location.reload()
            hideModal()
          })
        }}
      >
        yes
      </button>
    </>
  )
}
